import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isExternalUrl } from "../../Utils/ExternalRedirect";

// Website customers have no app bar around this page, so they get an in-page way back to the previous
// step (e.g. from the bank list to the payment categories). App orders already use the app's own back.
const WebsiteBackButton = () => {
  const navigate = useNavigate();
  const invoice = useSelector((state) => state.invoice?.transaction);

  if (!isExternalUrl(invoice?.succeed_redirect_url)) return null;

  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-danger radius-50 font-averta mb-3"
      onClick={() => navigate(-1)}
    >
      &larr; Kembali
    </button>
  );
};

export default WebsiteBackButton;
